var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.clickAdd)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "div",
                        { staticClass: "form-group col-md-6" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              tag: "section",
                              name: "科系類別",
                              rules: "required",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "科系類別",
                                          },
                                          model: {
                                            value: _vm.majorSubjectCategory,
                                            callback: function ($$v) {
                                              _vm.majorSubjectCategory = $$v
                                            },
                                            expression: "majorSubjectCategory",
                                          },
                                        },
                                        _vm._l(
                                          _vm.majorSubjectCategoryList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.Guid,
                                              attrs: {
                                                label: item.Name,
                                                value: item.Guid,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      errors
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group col-md-6" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              tag: "section",
                              name: "科系",
                              rules: "required",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "科系",
                                          },
                                          model: {
                                            value: _vm.majorSubject,
                                            callback: function ($$v) {
                                              _vm.majorSubject = $$v
                                            },
                                            expression: "majorSubject",
                                          },
                                        },
                                        _vm._l(
                                          _vm.majorSubjectList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.Guid,
                                              attrs: {
                                                label: item.Name,
                                                value: item.Guid,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      errors
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "form-row" }, [
                      _c("div", { staticClass: "form-group col-md-12" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.ManpowerDemandSchoolDepartment
                                  .SchoolDepartmentDescription,
                              expression:
                                "ManpowerDemandSchoolDepartment.SchoolDepartmentDescription",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", placeholder: "科系描述" },
                          domProps: {
                            value:
                              _vm.ManpowerDemandSchoolDepartment
                                .SchoolDepartmentDescription,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.ManpowerDemandSchoolDepartment,
                                "SchoolDepartmentDescription",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary btn-sm",
                          staticStyle: {
                            "margin-left": "6px",
                            "margin-right": "10px",
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.clickCancel.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" 取消 ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "submit" },
                        },
                        [_vm._v("儲存")]
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }